import { useCallback, useRef, useState, useEffect } from 'react'
import { logger } from '~/helpers/logger'
import { storeDocument, DOCUMENT_TYPES } from '~/services/api'

export const useUpload = (
  setisWebcamModal,
  setIsButtonFileDisable,
  setIsButtonDisabled,
  urls,
  setIsLoading,
  setWebcam,
  setFilesNotUpload,
  filesNotUpload
) => {
  const [image, setImage] = useState()
  const [status, setStatus] = useState('processing')
  const [isButtonModalDisabled, setIsButtonModalDisabled] = useState(false)

  useEffect(() => {
    if (status === 'complete') {
      setIsButtonFileDisable({ upload: true, take: false })
      setIsButtonDisabled(false)
    }
  }, [setIsButtonDisabled, setIsButtonFileDisable, status])

  const videoConstraints = {
    width: 640,
    height: 360,
    facingMode: 'user'
  }

  const webcamRef = useRef(null)

  const capture = useCallback(() => {
    const imageSrc = webcamRef.current.getScreenshot()
    setImage(imageSrc)
  }, [webcamRef])

  const b64toBlob = dataURI => {
    const byteString = atob(dataURI.split(',')[1])
    const ab = new ArrayBuffer(byteString.length)
    const ia = new Uint8Array(ab)

    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i)
    }
    return new Blob([ab], { type: 'image/jpeg' })
  }

  const onDrop = dropFile => {
    setIsLoading(true)
    const asset = localStorage.getItem('asset-ref')

    // setError(false)
    const reader = new FileReader()

    reader.onerror = err => {
      logger({ error: err, screen: 'component upload-file (fn onDrop)' })
    }

    reader.onload = async () => {
      // setStatus('processing')
      setFilesNotUpload([...filesNotUpload, ...dropFile])

      try {
        const storedFile = await storeDocument(dropFile[0], DOCUMENT_TYPES.selfie, asset)
        urls.setUrls([...urls.urls, { ...storedFile, type: asset }])

        setStatus('complete')

        setisWebcamModal(false)
        setIsButtonModalDisabled(false)
        setIsLoading(false)
        setWebcam(true)
      } catch (err) {
        logger({ error: err, screen: 'component upload-file (fn onDrop)' })
        setIsLoading(false)
      }
    }

    try {
      reader.readAsDataURL(dropFile[0])
    } catch (err) {
      logger({ error: err, screen: 'component upload-file (fn onDrop)' })
      setIsLoading(false)
    }
  }

  const handleImage = () => {
    if (!image) {
      capture()
    } else {
      const blob = b64toBlob(image)
      setIsButtonModalDisabled(true)
      onDrop([blob])
    }
  }

  const completeClick = () => {
    if (image) {
      setIsButtonModalDisabled(true)
    }

    setisWebcamModal(true)
  }

  const takeNewPhoto = () => {
    setIsButtonModalDisabled(false)
    setImage(null)
  }

  return [handleImage, image, webcamRef, videoConstraints, status, isButtonModalDisabled, completeClick, takeNewPhoto]
}

export const useVideoUpload = (
  setisWebcamModal,
  setIsButtonFileDisable,
  setIsButtonDisabled,
  urls,
  setIsLoading,
  setWebcam,
  setFilesNotUpload,
  filesNotUpload
) => {
  const [video, setVideo] = useState()
  const [error, setError] = useState(false)
  const [status, setStatus] = useState('processing')
  const [isButtonModalDisabled, setIsButtonModalDisabled] = useState(true)

  useEffect(() => {
    if (status === 'complete') {
      setIsButtonFileDisable({ upload: true, take: false })
      setIsButtonDisabled(false)
    }
  }, [setIsButtonDisabled, setIsButtonFileDisable, status])

  const onDrop = file => {
    setIsLoading(true)
    const asset = localStorage.getItem('asset-ref')
    setIsButtonModalDisabled(true)

    setError(false)
    const reader = new FileReader()

    reader.onerror = readerError => {
      logger({ error: readerError, screen: 'component upload-file (fn onDrop)' })
    }

    reader.onload = async () => {
      setStatus('processing')
      setFilesNotUpload([...filesNotUpload, ...file])

      try {
        const storedFile = await storeDocument(file[0], DOCUMENT_TYPES.selfie, asset)
        setStatus('complete')
        urls.setUrls([...urls.urls, { ...storedFile, type: asset }])

        setisWebcamModal(false)
        setIsButtonModalDisabled(false)
        setIsButtonDisabled(false)
        setIsLoading(false)
        setWebcam(true)
      } catch (err) {
        logger({ error: err, screen: 'component upload-file (fn onDrop)' })
        setIsLoading(false)
      }
    }

    try {
      reader.readAsDataURL(file[0])
    } catch (err) {
      logger({ error: err, screen: 'component upload-file (fn onDrop)' })
    }
  }

  const handleVideo = () => {
    if (video) {
      setIsButtonModalDisabled(false)
      onDrop([video])
    }
  }

  const completeClick = () => {
    if (video) {
      setIsButtonModalDisabled(true)
    }

    setisWebcamModal(true)
  }

  return [handleVideo, setVideo, status, isButtonModalDisabled, setIsButtonModalDisabled, completeClick, error]
}
